/* unplugin-vue-components disabled */import script from "./MyPaginationOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPaginationOrder.vue?vue&type=script&setup=true&lang=js"

import "./MyPaginationOrder.vue?vue&type=style&index=0&id=f6e24aac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6e24aac"]])

export default __exports__